import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Subscription } from 'rxjs';
import { SortOption } from '../../models/sortOption';
import { BaseODataService } from '../../services/base-odata.service';
import { CustomViewDisplayLayout } from '../odata-filter/models/custom-view-display-layout';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit, OnDestroy {
  customViewDisplayLayoutEnum = CustomViewDisplayLayout;
  resultCount: number;
  subs: Subscription[] = [];

  @Input() customViewDisplayLayout: CustomViewDisplayLayout;
  @Input() currentSortOption: SortOption;
  @Input() sortOptions: SortOption[] = [];
  @Input() filterService: BaseODataService;
  @Output() sortChange = new EventEmitter<{ active: string; direction: string }>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor() {}

  ngOnInit(): void {
    this.subs.push(
      this.filterService.filterResultValues.subscribe(() => {
        this.resultCount = this.filterService.totalResultCount;
      }),
      this.filterService.appliedFilters.subscribe(() => {
        if (this.paginator) {
          this.paginator.pageIndex = 0;
        }
      })
    );
  }
  changeSort(sortOption: SortOption) {
    this.currentSortOption = sortOption;
    this.sortChange.emit({
      active: this.currentSortOption.property,
      direction: this.currentSortOption.orderType,
    });
  }
  pageChanged(event: PageEvent) {
    if (event.previousPageIndex > event.pageIndex) {
      this.filterService.gotoPreviousPage();
    } else {
      this.filterService.gotoNextPage();
    }
  }
  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
